import type {TreeNode} from '@hconnect/common/types'

import {ItemDetailsLayout} from '../../plant-setup-item-layout'

import {AssetLayout} from './AssetLayout'

interface LayoutProps {
  selectedItem: TreeNode
}

export const Layout: React.FC<LayoutProps> = ({selectedItem}) => {
  return (
    <ItemDetailsLayout>
      <AssetLayout assetId={selectedItem.upmId} />
    </ItemDetailsLayout>
  )
}
